import React from 'react';

import {SupportTickets, LargeChat, ActiveUsersService} from 'Components/Networking/Sub';

import ToApi from 'Services/Api/Networking/To';

import {translation} from 'Services/TranslationHelpers';

export default class AdminSupportTickets extends React.Component {
    /**
     * @var state
     */
    state = {
        selected_chat: null,
        mobile_active_column: 'support_tickets',
        error_message: null
    }

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        ActiveUsersService.subscribe();

        this.setSelectedChatOnLoad();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount() {
        ActiveUsersService.unsubscribe();
    }

    /**
     * @method setSelectedChatOnLoad
     */
    setSelectedChatOnLoad = async () => {
        const {selectedMessageToType, selectedMessageToId} = this.props;

        if (selectedMessageToType && selectedMessageToId) {
            const response = await ToApi.get(selectedMessageToId, {
                message_to_type: selectedMessageToType
            });

            if (response.success) {
                this.setSelectedChat(response.data.data);
            } else {
                this.setState({
                    error_message: 'Invalid pre-select'
                });
            }
        }
    }

    /**
     * @method setSelectedChat
     * @param {object} user
     */
    setSelectedChat = (user) => {
        this.setState({
            selected_chat: user,
            mobile_active_column: 'chat'
        });
    }

    /**
     * @method getColumns
     * @return {array}
     */
    getColumns = () => {
        return {
            'support_tickets': {
                component: SupportTickets,
                className: 'w-full lg:w-4/12 mx-0 lg:mx-2 h-full'
            },
            'chat': {
                component: LargeChat,
                className: 'w-full lg:w-8/12 mx-0 lg:mx-2'
            }
        };
    }

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {error_message} = this.state;

        if (error_message) {
            return (
                <div className="text-center font-bold">
                    {error_message}
                </div>
            );
        }

        return (
            <div className="networking-container h-full flex flex-col lg:flex-row">
                {this.renderMobileControls()}
                {this.renderColumns()}
            </div>
        );
    }

    /**
     * @method renderMobileControls
     * @return {*}
     */
    renderMobileControls() {
        const {mobile_active_column} = this.state;

        let columns = Object.entries(this.getColumns());

        return (
            <div className="z-10 min-w-full h-11 grid grid-cols-3 lg:hidden">
                {columns.map((column, i) => (
                    <div
                        className={`
                            p-2 large text-center cursor-pointer border border-networking-primary
                            ${mobile_active_column === column[0] ?
                                'bg-networking-primary text-networking-primary-text' :
                                'bg-networking-primary-text text-networking-primary'}
                        `}
                        onClick={() => this.setState({mobile_active_column: column[0]})}
                        key={i}
                    >
                        {translation('networking_frontend', column[0] + '_title')}
                    </div>
                ))}
            </div>
        );
    }

    /**
     * @method renderColumns
     * @return {*}
     */
    renderColumns() {
        const {mobile_active_column, selected_chat} = this.state;

        let columns = Object.entries(this.getColumns());

        return (
            <div className="flex min-w-full 'min-h-screen h-screen">
                {columns.map((column, i) => {
                    let Component = column[1].component;

                    return (
                        <div
                            className={`
                                ${column[1].className}
                                ${mobile_active_column === column[0] ? 'inline' : 'hidden'}
                                lg:inline
                            `}
                            key={i}
                        >
                            <Component
                                setSelectedChat={(user) => this.setSelectedChat(user)}
                                selected_chat={selected_chat}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}
